{
  "HELP_CENTER": {
    "TITLE": "Centro assistenza",
    "NEW_PAGE": {
      "DESCRIPTION": "Crea portali di assistenza self-service per i tuoi clienti. Aiutali a trovare rapidamente le risposte, senza attese. Semplifica le richieste, aumenta l'efficienza degli agenti e migliora l'assistenza clienti.",
      "CREATE_PORTAL_BUTTON": "Crea portale"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Senza titolo"
    },
    "HEADER": {
      "FILTER": "Filtra per",
      "SORT": "Ordina per",
      "LOCALE": "Lingua",
      "SETTINGS_BUTTON": "Impostazioni",
      "NEW_BUTTON": "Nuovo articolo",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Pubblicato",
        "DRAFT": "Draft",
        "ARCHIVED": "Archiviato"
      },
      "TITLES": {
        "ALL_ARTICLES": "Tutti gli articoli",
        "MINE": "I miei articoli",
        "DRAFT": "Articoli Draft",
        "ARCHIVED": "Articoli archiviati"
      },
      "LOCALE_SELECT": {
        "TITLE": "Seleziona lingua",
        "PLACEHOLDER": "Seleziona lingua",
        "NO_RESULT": "Nessuna lingua trovata",
        "SEARCH_PLACEHOLDER": "Cerca lingua"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Tutti gli articoli",
      "PUBLISH_BUTTON": "Pubblica",
      "MOVE_TO_ARCHIVE_BUTTON": "Sposta nell'archivio",
      "PREVIEW": "Anteprima",
      "ADD_TRANSLATION": "Aggiungi traduzione",
      "OPEN_SIDEBAR": "Apri barra laterale",
      "CLOSE_SIDEBAR": "Chiudi barra laterale",
      "SAVING": "Salvataggio...",
      "SAVED": "Salvato"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Carica immagine",
        "UPLOADING": "Caricamento...",
        "SUCCESS": "Immagine caricata con successo",
        "ERROR": "Errore durante il caricamento dell'immagine",
        "UN_AUTHORIZED_ERROR": "Non sei autorizzato a caricare immagini",
        "ERROR_FILE_SIZE": "La dimensione dell'immagine deve essere inferiore a {size}MB",
        "ERROR_FILE_FORMAT": "Il formato dell'immagine deve essere jpg, jpeg o png",
        "ERROR_FILE_DIMENSIONS": "Le dimensioni dell'immagine devono essere inferiori a 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Inserisci àncora",
        "TITLE": "Inserisci àncora",
        "SUBMIT": "Inserisci",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Impostazioni articolo",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Categoria",
          "TITLE": "Seleziona categoria",
          "PLACEHOLDER": "Seleziona categoria",
          "NO_RESULT": "Nessuna categoria trovata",
          "SEARCH_PLACEHOLDER": "Cerca categoria"
        },
        "AUTHOR": {
          "LABEL": "Autore",
          "TITLE": "Seleziona autore",
          "PLACEHOLDER": "Seleziona autore",
          "NO_RESULT": "Nessun autore trovato",
          "SEARCH_PLACEHOLDER": "Cerca autore"
        },
        "META_TITLE": {
          "LABEL": "Titolo meta",
          "PLACEHOLDER": "Aggiungi un titolo meta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Descrizione meta",
          "PLACEHOLDER": "Aggiungi la tua descrizione meta per migliori risultati SEO..."
        },
        "META_TAGS": {
          "LABEL": "Tag meta",
          "PLACEHOLDER": "Aggiungi tag meta separati da virgola..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archivia articolo",
        "DELETE": "Elimina articolo"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Senza categoria",
      "SEARCH_RESULTS": "Risultati di ricerca per {query}",
      "EMPTY_TEXT": "Cerca articoli da inserire nelle risposte.",
      "SEARCH_LOADER": "Ricerca in corso...",
      "INSERT_ARTICLE": "Inserisci",
      "NO_RESULT": "Nessun articolo trovato",
      "COPY_LINK": "Copia il link dell'articolo negli appunti",
      "OPEN_LINK": "Apri l'articolo in una nuova scheda",
      "PREVIEW_LINK": "Anteprima articolo"
    },
    "PORTAL": {
      "HEADER": "Portali",
      "DEFAULT": "Predefinito",
      "NEW_BUTTON": "Nuovo portale",
      "ACTIVE_BADGE": "attivo",
      "CHOOSE_LOCALE_LABEL": "Scegli una lingua",
      "LOADING_MESSAGE": "Caricamento dei portali...",
      "ARTICLES_LABEL": "articoli",
      "NO_PORTALS_MESSAGE": "Non ci sono portali disponibili",
      "ADD_NEW_LOCALE": "Aggiungi una nuova lingua",
      "POPOVER": {
        "TITLE": "Portali",
        "PORTAL_SETTINGS": "Impostazioni del portale",
        "SUBTITLE": "Hai più portali e puoi avere diverse lingue per ogni portale.",
        "CANCEL_BUTTON_LABEL": "Annulla",
        "CHOOSE_LOCALE_BUTTON": "Scegli lingua"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "articoli",
            "ADD": "Aggiungi lingua",
            "VISIT": "Visita sito",
            "SETTINGS": "Impostazioni",
            "DELETE": "Elimina"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Configurazioni portale",
            "ITEMS": {
              "NAME": "Nome",
              "DOMAIN": "Dominio personalizzato",
              "SLUG": "Slug",
              "TITLE": "Titolo del portale",
              "THEME": "Colore del tema",
              "SUB_TEXT": "Sottotesto del portale"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Lingue disponibili",
            "TABLE": {
              "NAME": "Nome lingua",
              "CODE": "Codice lingua",
              "ARTICLE_COUNT": "N° di articoli",
              "CATEGORIES": "N. di categorie",
              "SWAP": "Scambia",
              "DELETE": "Elimina",
              "DEFAULT_LOCALE": "Predefinito"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Elimina portale",
          "MESSAGE": "Sei sicuro di voler eliminare questo portale",
          "YES": "Sì, elimina il portale",
          "NO": "No, mantieni il portale",
          "API": {
            "DELETE_SUCCESS": "Portale eliminato con successo",
            "DELETE_ERROR": "Errore durante l'eliminazione del portale"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Modifica portale",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Informazioni di base"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Personalizzazione del portale"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categorie"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Lingue"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categorie in",
          "NEW_CATEGORY": "Nuova categoria",
          "TABLE": {
            "NAME": "Nome",
            "DESCRIPTION": "Descrizione",
            "LOCALE": "Lingua",
            "ARTICLE_COUNT": "N° di articoli",
            "ACTION_BUTTON": {
              "EDIT": "Modifica categoria",
              "DELETE": "Elimina categoria"
            },
            "EMPTY_TEXT": "Nessuna categoria trovata"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Aggiorna impostazioni di base"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informazioni del centro assistenza",
            "BODY": "Informazioni di base sul portale"
          },
          "CUSTOMIZATION": {
            "TITLE": "Personalizzazione del centro assistenza",
            "BODY": "Personalizza portale"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "È tutto pronto!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Indietro",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Crea portale",
            "TITLE": "Informazioni del centro assistenza",
            "CREATE_BASIC_SETTING_BUTTON": "Crea impostazioni di base del portale"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Personalizzazione del portale",
            "TITLE": "Personalizzazione del centro assistenza",
            "UPDATE_PORTAL_BUTTON": "Aggiorna impostazioni del portale"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 È tutto configurato!",
            "MESSAGE": "Ora puoi vedere questo portale creato sulla pagina di tutti i portali.",
            "FINISH": "Vai a tutti i portali"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Carica logo",
          "HELP_TEXT": "Questo logo verrà visualizzato nell'intestazione del portale.",
          "IMAGE_UPLOAD_SUCCESS": "Logo caricato con successo",
          "IMAGE_UPLOAD_ERROR": "Logo eliminato con successo",
          "IMAGE_DELETE_ERROR": "Errore durante l'eliminazione del logo"
        },
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome del portale",
          "HELP_TEXT": "Il nome sarà utilizzato nel portale pubblico rivolto internamente.",
          "ERROR": "Il nome è obbligatorio"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portale per URL",
          "ERROR": "Slug è obbligatorio"
        },
        "DOMAIN": {
          "LABEL": "Dominio personalizzato",
          "PLACEHOLDER": "Dominio personalizzato del portale",
          "HELP_TEXT": "Aggiungilo solo se vuoi utilizzare un dominio personalizzato per i tuoi portali. Es: {exampleURL}",
          "ERROR": "Inserisci un URL di dominio valido"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link pagina iniziale",
          "PLACEHOLDER": "Link della pagina iniziale del portale",
          "HELP_TEXT": "Il link utilizzato per tornare dal portale alla home page. Es: {exampleURL}",
          "ERROR": "Inserisci un URL valido per la home page"
        },
        "THEME_COLOR": {
          "LABEL": "Colore tema del portale",
          "HELP_TEXT": "Questo colore verrà mostrato come colore del tema per il portale."
        },
        "PAGE_TITLE": {
          "LABEL": "Titolo pagina",
          "PLACEHOLDER": "Titolo pagina del portale",
          "HELP_TEXT": "Il titolo della pagina verrà utilizzato nel portale pubblico.",
          "ERROR": "Il titolo della pagina è obbligatorio"
        },
        "HEADER_TEXT": {
          "LABEL": "Testo intestazione",
          "PLACEHOLDER": "Testo intestazione del portale",
          "HELP_TEXT": "Il testo dell'intestazione del portale sarà utilizzato nel portale pubblico.",
          "ERROR": "Il testo dell'intestazione del portale è obbligatorio"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portale creato con successo.",
          "ERROR_MESSAGE_FOR_BASIC": "Impossibile creare il portale. Riprova.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portale aggiornato con successo.",
          "ERROR_MESSAGE_FOR_UPDATE": "Impossibile aggiornare il portale. Riprova."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Aggiungi una nuova lingua",
        "SUB_TITLE": "Questo aggiunge un nuova lingua alla tua lista di traduzioni disponibili.",
        "PORTAL": "Portale",
        "LOCALE": {
          "LABEL": "Lingua",
          "PLACEHOLDER": "Scegli una lingua",
          "ERROR": "Lingua richiesta"
        },
        "BUTTONS": {
          "CREATE": "Crea lingua",
          "CANCEL": "Annulla"
        },
        "API": {
          "SUCCESS_MESSAGE": "Lingua aggiunta con successo",
          "ERROR_MESSAGE": "Impossibile aggiungere la lingua. Riprova."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Lingua predefinita aggiornata correttamente",
          "ERROR_MESSAGE": "Impossibile aggiornare la lingua predefinita. Riprova."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Lingua rimossa dal portale con successo",
          "ERROR_MESSAGE": "Impossibile rimuovere la lingua dal portale. Riprova."
        }
      }
    },
    "TABLE": {
      "404": "Nessun articolo corrisponde alla tua ricerca 🔍",
      "LOADING_MESSAGE": "Caricamento articoli...",
      "NO_ARTICLES": "Non ci sono articoli disponibili",
      "HEADERS": {
        "TITLE": "Titolo",
        "CATEGORY": "Categoria",
        "READ_COUNT": "Visualizzazioni",
        "STATUS": "Stato",
        "LAST_EDITED": "Ultima modifica"
      },
      "COLUMNS": {
        "BY": "di",
        "AUTHOR_NOT_AVAILABLE": "Autore non disponibile"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Caricamento articolo...",
      "TITLE_PLACEHOLDER": "Il titolo dell'articolo va qui",
      "CONTENT_PLACEHOLDER": "Scrivi qui il tuo articolo",
      "API": {
        "ERROR": "Errore durante il salvataggio dell'articolo"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Errore durante la pubblicazione dell'articolo",
        "SUCCESS": "Articolo pubblicato con successo"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Errore durante l'archiviazione dell'articolo",
        "SUCCESS": "Articolo archiviato con successo"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Errore durante il salvataggio dell'articolo come Draft",
        "SUCCESS": "Articolo salvato come Draft con successo"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Conferma eliminazione",
          "MESSAGE": "Sei sicuro di voler eliminare l'articolo?",
          "YES": "Sì, elimina",
          "NO": "No, conserva"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Articolo eliminato con successo",
        "ERROR_MESSAGE": "Errore durante l'eliminazione dell'articolo"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Si prega di aggiungere l'intestazione e il contenuto dell'articolo quindi solo è possibile aggiornare le impostazioni"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Cerca articoli"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Crea una categoria",
        "SUB_TITLE": "La categoria sarà utilizzata nel portale pubblico per classificare gli articoli.",
        "PORTAL": "Portale",
        "LOCALE": "Lingua",
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome categoria",
          "HELP_TEXT": "Il nome e l'icona della categoria saranno utilizzati nel portale pubblico per classificare gli articoli.",
          "ERROR": "Il nome è obbligatorio"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug categoria per url",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug è obbligatorio"
        },
        "DESCRIPTION": {
          "LABEL": "Descrizione",
          "PLACEHOLDER": "Fornisci una breve descrizione della categoria.",
          "ERROR": "La descrizione è obbligatoria"
        },
        "BUTTONS": {
          "CREATE": "Crea categoria",
          "CANCEL": "Annulla"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria creata con successo",
          "ERROR_MESSAGE": "Impossibile creare la categoria"
        }
      },
      "EDIT": {
        "TITLE": "Modifica una categoria",
        "SUB_TITLE": "Modificare una categoria aggiornerà la categoria nel portale pubblico.",
        "PORTAL": "Portale",
        "LOCALE": "Lingua",
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome categoria",
          "HELP_TEXT": "Il nome e l'icona della categoria saranno utilizzati nel portale pubblico per classificare gli articoli.",
          "ERROR": "Il nome è obbligatorio"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug categoria per url",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug è obbligatorio"
        },
        "DESCRIPTION": {
          "LABEL": "Descrizione",
          "PLACEHOLDER": "Fornisci una breve descrizione della categoria.",
          "ERROR": "La descrizione è obbligatoria"
        },
        "BUTTONS": {
          "CREATE": "Aggiorna categoria",
          "CANCEL": "Annulla"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria aggiornata con successo",
          "ERROR_MESSAGE": "Impossibile aggiornare la categoria"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Categoria eliminata con successo",
          "ERROR_MESSAGE": "Impossibile eliminare la categoria"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Cerca articoli",
      "PLACEHOLDER": "Cerca articoli",
      "NO_RESULT": "Nessun articolo trovato",
      "SEARCHING": "Ricerca in corso...",
      "SEARCH_BUTTON": "Cerca",
      "INSERT_ARTICLE": "Inserisci link",
      "IFRAME_ERROR": "L'URL è vuoto o non valido. Impossibile visualizzare il contenuto.",
      "OPEN_ARTICLE_SEARCH": "Inserisci articolo dal Centro assistenza",
      "SUCCESS_ARTICLE_INSERTED": "Articolo inserito con successo",
      "PREVIEW_LINK": "Anteprima articolo",
      "CANCEL": "Chiudi",
      "BACK": "Indietro",
      "BACK_RESULTS": "Torna ai risultati"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centro assistenza",
      "DESCRIPTION": "Crea portali self-service intuitivi. Aiuta i tuoi utenti ad accedere agli articoli e a ricevere supporto 24/7. Aggiorna il tuo abbonamento per attivare questa funzionalità.",
      "SELF_HOSTED_DESCRIPTION": "Crea portali self-service intuitivi. Aiuta i tuoi utenti ad accedere agli articoli e a ricevere supporto 24/7. Contatta il tuo amministratore per attivare questa funzionalità.",
      "BUTTON": {
        "LEARN_MORE": "Scopri di più",
        "UPGRADE": "Esegui l'upgrade"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Portali multipli",
          "DESCRIPTION": "Crea più portali del centro assistenza per prodotti diversi utilizzando lo stesso account."
        },
        "LOCALES": {
          "TITLE": "Supporto completo per le lingue",
          "DESCRIPTION": "Localizza il portale nella tua lingua. Supportiamo tutte le lingue e consentiamo la traduzione di ogni articolo."
        },
        "SEO": {
          "TITLE": "Design ottimizzato per la SEO",
          "DESCRIPTION": "Personalizza i tuoi meta tag per migliorare la tua visibilità sui motori di ricerca con le nostre pagine ottimizzate per la SEO."
        },
        "API": {
          "TITLE": "Supporto completo per le API",
          "DESCRIPTION": "Usa il portale come CMS headless con framework front-end di terze parti utilizzando le nostre API."
        }
      }
    },
    "LOADING": "Caricamento...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} visualizzazione | {count} visualizzazioni",
          "DROPDOWN_MENU": {
            "PUBLISH": "Pubblica",
            "DRAFT": "Draft",
            "ARCHIVE": "Archivia",
            "DELETE": "Elimina"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Pubblicato",
            "ARCHIVED": "Archiviato"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Senza categoria"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Tutti gli articoli",
          "MINE": "Mie",
          "DRAFT": "Draft",
          "PUBLISHED": "Pubblicato",
          "ARCHIVED": "Archiviato"
        },
        "CATEGORY": {
          "ALL": "Tutte le categorie"
        },
        "LOCALE": {
          "ALL": "Tutte le lingue"
        },
        "NEW_ARTICLE": "Nuovo articolo"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Scrivi un articolo",
          "SUBTITLE": "Scrivi un articolo ricco, iniziamo!",
          "BUTTON_LABEL": "Nuovo articolo"
        },
        "MINE": {
          "TITLE": "Non hai ancora scritto nessun articolo qui",
          "SUBTITLE": "Tutti gli articoli scritti da te compaiono qui per un accesso rapido."
        },
        "DRAFT": {
          "TITLE": "Non ci sono articoli in Draft",
          "SUBTITLE": "Gli articoli Draft appariranno qui"
        },
        "PUBLISHED": {
          "TITLE": "Non ci sono articoli pubblicati",
          "SUBTITLE": "Gli articoli pubblicati appariranno qui"
        },
        "ARCHIVED": {
          "TITLE": "Non ci sono articoli nell'archivio",
          "SUBTITLE": "Gli articoli archiviati non vengono visualizzati sul portale; puoi usarli per contrassegnare pagine deprecate o obsolete"
        },
        "CATEGORY": {
          "TITLE": "Non ci sono articoli in questa categoria",
          "SUBTITLE": "Gli articoli di questa categoria appariranno qui"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nuova categoria",
        "EDIT_CATEGORY": "Modifica categoria",
        "CATEGORIES_COUNT": "{n} categoria | {n} categorie",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categorie ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} articoli) | {categoryName} ({categoryCount} articolo)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nessuna categoria trovata",
        "SUBTITLE": "Le categorie appariranno qui. Puoi aggiungere una categoria facendo clic sul pulsante 'Nuova categoria'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} articolo | {count} articoli",
        "EXPAND": "Mostra sottocategorie",
        "COLLAPSE": "Nascondi sottocategorie",
        "MENU": {
          "NEW_ARTICLE": "Nuovo articolo",
          "ADD_SUBCATEGORY": "Aggiungi sottocategoria",
          "EDIT": "Modifica",
          "DELETE": "Elimina"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria creata con successo",
            "ERROR_MESSAGE": "Impossibile creare la categoria"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria aggiornata con successo",
            "ERROR_MESSAGE": "Impossibile aggiornare la categoria"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria eliminata con successo",
            "ERROR_MESSAGE": "Impossibile eliminare la categoria"
          },
          "CONFIRM": {
            "TITLE": "Elimina categoria",
            "DESCRIPTION": "Sei sicuro di voler eliminare questa categoria? I suoi articoli diventeranno senza categoria.",
            "DESCRIPTION_WITH_CHILDREN": "Sei sicuro di voler eliminare questa categoria? I suoi articoli diventeranno senza categoria e la sua {count} sottocategoria verrà spostata al livello superiore. | Sei sicuro di voler eliminare questa categoria? I suoi articoli diventeranno senza categoria e le sue {count} sottocategorie verranno spostate al livello superiore.",
            "CONFIRM": "Elimina"
          }
        },
        "HEADER": {
          "CREATE": "Crea categoria",
          "EDIT": "Modifica categoria",
          "DESCRIPTION": "Modificare una categoria aggiornerà la categoria nel portale pubblico.",
          "PORTAL": "Portale",
          "LOCALE": "Lingua"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nome",
            "PLACEHOLDER": "Nome categoria",
            "ERROR": "Il nome è obbligatorio"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug categoria per url",
            "ERROR": "Slug è obbligatorio",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Descrizione",
            "PLACEHOLDER": "Fornisci una breve descrizione della categoria.",
            "ERROR": "La descrizione è obbligatoria"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Categoria principale",
            "PLACEHOLDER": "Seleziona una categoria principale",
            "NONE": "Nessuna (livello principale)"
          }
        },
        "BUTTONS": {
          "CREATE": "Crea",
          "EDIT": "Aggiorna",
          "CANCEL": "Annulla"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Nessuna lingua disponibile | {n} lingua | {n} lingue",
      "NEW_LOCALE_BUTTON_TEXT": "Nuova lingua",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} articolo | {count} articoli",
        "CATEGORIES_COUNT": "{count} categoria | {count} categorie",
        "DEFAULT": "Predefinito",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Imposta come predefinito",
          "DELETE": "Elimina"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Aggiungi una nuova lingua",
        "DESCRIPTION": "Seleziona la lingua in cui verrà scritto questo articolo. Verrà aggiunta al tuo elenco di traduzioni e potrai aggiungerne altre in seguito.",
        "COMBOBOX": {
          "PLACEHOLDER": "Seleziona lingua..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Lingua aggiunta con successo",
          "ERROR_MESSAGE": "Impossibile aggiungere la lingua. Riprova."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Salvataggio...",
          "SAVED": "Salvato"
        },
        "PREVIEW": "Anteprima",
        "PUBLISH": "Pubblica",
        "DRAFT": "Draft",
        "ARCHIVE": "Archivia",
        "BACK_TO_ARTICLES": "Torna agli articoli"
      },
      "DRAFT": {
        "PENDING_LABEL": "Modifiche non pubblicate",
        "PROMOTE": "Pubblica modifiche",
        "DISCARD": "Annulla modifiche",
        "PROMOTE_SUCCESS": "Modifiche Draft pubblicate nell'articolo attivo",
        "PROMOTE_ERROR": "Impossibile pubblicare le modifiche Draft",
        "DISCARD_SUCCESS": "Modifiche Draft annullate",
        "DISCARD_ERROR": "Impossibile annullare le modifiche Draft"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Cronologia versioni",
        "TITLE": "Cronologia versioni",
        "BACK": "Torna all'articolo",
        "LOADING": "Caricamento versioni...",
        "EMPTY": "Nessuna versione ancora. Le modifiche a questo articolo appariranno qui.",
        "EMPTY_CONTENT": "Questa versione non ha contenuto.",
        "CURRENT_BADGE": "Attuale",
        "RESTORED_BADGE": "Ripristinata",
        "AUTOMATED_USER": "Aggiornamento automatico",
        "RESTORE": "Ripristina questa versione",
        "RESTORE_DIALOG": {
          "TITLE": "Ripristinare questa versione?",
          "DESCRIPTION": "L'articolo tornerà al testo di questa versione. Non si perde nulla — il testo attuale resta nella cronologia e un articolo pubblicato continua a mostrare la versione attiva finché non pubblichi la modifica.",
          "CONFIRM": "Ripristina"
        },
        "RESTORE_SUCCESS": "Versione ripristinata",
        "RESTORE_ERROR": "Impossibile ripristinare questa versione",
        "FETCH_ERROR": "Impossibile caricare la cronologia delle versioni"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Altre proprietà",
        "TRANSLATE": "Traduci",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Senza categoria",
        "EDITOR_PLACEHOLDER": "Scrivi qualcosa...",
        "HTML_EMBED": {
          "TITLE": "Inserisci HTML personalizzato",
          "DESCRIPTION": "Incolla HTML grezzo come un iframe, un embed o uno snippet di widget. Verrà visualizzato così com'è nell'articolo pubblicato.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Inserisci"
        },
        "PRIMARY_CATEGORY": "Categoria principale"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Proprietà articolo",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Descrizione meta",
        "META_DESCRIPTION_PLACEHOLDER": "Aggiungi descrizione meta",
        "META_TITLE": "Titolo meta",
        "META_TITLE_PLACEHOLDER": "Aggiungi titolo meta",
        "META_TAGS": "Tag meta",
        "META_TAGS_PLACEHOLDER": "Aggiungi tag meta",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Varianti linguistiche",
        "LANGUAGE_MUTATIONS_EMPTY": "Nessun articolo collegato",
        "ADD_MUTATION": "Aggiungi",
        "REMOVE_MUTATION": "Rimuovi"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Collega varianti linguistiche",
        "SEARCH_PLACEHOLDER": "Cerca articoli per titolo",
        "EMPTY": "Nessun articolo trovato",
        "CANCEL": "Annulla",
        "ADD_SELECTED": "Aggiungi selezionati",
        "SUCCESS": "Varianti aggiornate",
        "ERROR": "Impossibile aggiornare le varianti"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Traduci articolo",
        "DESCRIPTION": "Seleziona le lingue in cui vuoi tradurre questo articolo. Le lingue già tradotte verranno ritradotte in un Draft da rivedere.",
        "EMPTY": "Nessun'altra lingua è disponibile.",
        "CONNECTED_BADGE": "Tradotto",
        "CANCEL": "Annulla",
        "TRANSLATE": "Traduci",
        "SUCCESS": "La traduzione inizierà a breve. Gli articoli tradotti appariranno presto come varianti linguistiche.",
        "ERROR": "Impossibile avviare la traduzione"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Errore durante il salvataggio dell'articolo"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nuovo portale",
      "PORTALS": "Portali",
      "CREATE_PORTAL": "Crea e gestisci più portali",
      "ARTICLES": "articoli",
      "DOMAIN": "dominio",
      "PORTAL_NAME": "Nome del portale"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Crea nuovo portale",
      "DESCRIPTION": "Dai un nome al tuo portale e crea uno slug URL semplice da usare. Potrai modificare entrambi in seguito nelle impostazioni.",
      "CONFIRM_BUTTON_LABEL": "Crea",
      "NAME": {
        "LABEL": "Nome",
        "PLACEHOLDER": "Guida utente",
        "MESSAGE": "Scegli un nome per il tuo portale.",
        "ERROR": "Il nome è obbligatorio"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug è obbligatorio",
        "FORMAT_ERROR": "Usa solo lettere, numeri e trattini, ad esempio: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Impossibile caricare l'immagine! Riprova",
          "IMAGE_UPLOAD_SUCCESS": "Immagine aggiunta con successo. Fai clic su salva modifiche per salvare il logo",
          "IMAGE_DELETE_SUCCESS": "Logo eliminato con successo",
          "IMAGE_DELETE_ERROR": "Impossibile eliminare il logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "La dimensione dell'immagine deve essere inferiore a {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome del portale",
          "ERROR": "Il nome è obbligatorio"
        },
        "HEADER_TEXT": {
          "LABEL": "Testo intestazione",
          "PLACEHOLDER": "Testo intestazione del portale"
        },
        "PAGE_TITLE": {
          "LABEL": "Titolo pagina",
          "PLACEHOLDER": "Titolo pagina del portale"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link pagina iniziale",
          "PLACEHOLDER": "Link della pagina iniziale del portale",
          "ERROR": "URL non valido. Il link della pagina iniziale deve iniziare con 'http://' o 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug del portale"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget di live chat",
          "PLACEHOLDER": "Seleziona widget di live chat",
          "HELP_TEXT": "Seleziona un widget di live chat che apparirà nel tuo centro assistenza"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Accessibile al pubblico",
          "HELP_TEXT": "Rendi il portale accessibile a tutti tramite link.",
          "OPTIONS": {
            "PUBLIC": "Sì",
            "PRIVATE": "No"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Destinazione del link",
          "HELP_TEXT": "Scegli se i link all'interno degli articoli si aprono nella finestra corrente o in una nuova.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Finestra corrente",
            "NEW_WINDOW": "Nuova finestra"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Dimensione immagine predefinita",
          "HELP_TEXT": "Dimensione applicata a ogni immagine che inserisci in un articolo. Scegli Originale per inserire le immagini nella loro dimensione originale, oppure seleziona una dimensione per ogni immagine."
        },
        "BRAND_COLOR": {
          "LABEL": "Colore del brand"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML personalizzato",
          "PLACEHOLDER": "<!-- Incolla qui il tuo snippet di analisi o monitoraggio -->",
          "HELP_TEXT": "Inserito all'inizio del tag <body> in ogni pagina del centro assistenza. Usalo per Google Analytics, Google Tag Manager o qualsiasi altro snippet di monitoraggio. Il codice viene visualizzato esattamente come inserito e non viene convalidato."
        },
        "SAVE_CHANGES": "Salva modifiche"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Dominio personalizzato",
          "LABEL": "Dominio personalizzato:",
          "DESCRIPTION": "Puoi ospitare il tuo portale su un dominio personalizzato. Ad esempio, se il tuo sito web è yourdomain.com e vuoi che il tuo portale sia disponibile su docs.yourdomain.com, inserisci semplicemente questo indirizzo in questo campo.",
          "PLACEHOLDER": "Dominio personalizzato del portale",
          "EDIT_BUTTON": "Modifica dominio personalizzato",
          "ADD_BUTTON": "Aggiungi dominio personalizzato",
          "DIALOG": {
            "ADD_HEADER": "Aggiungi dominio personalizzato",
            "EDIT_HEADER": "Modifica dominio personalizzato",
            "ADD_CONFIRM_BUTTON_LABEL": "Aggiungi dominio",
            "EDIT_CONFIRM_BUTTON_LABEL": "Aggiorna dominio",
            "LABEL": "Dominio personalizzato",
            "PLACEHOLDER": "Dominio personalizzato del portale",
            "ERROR": "Il dominio personalizzato è obbligatorio"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Configurazione DNS",
            "DESCRIPTION": "Accedi all'account che hai con il tuo provider DNS e aggiungi il record CNAME riportato qui sotto per il tuo sottodominio.",
            "HELP_TEXT": "Una volta fatto, puoi contattare il nostro supporto per richiedere il certificato SSL generato automaticamente.",
            "CONFIRM_BUTTON_LABEL": "Capito!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Elimina {portalName}",
          "HEADER": "Elimina portale",
          "DESCRIPTION": "Elimina definitivamente questo portale. Questa azione è irreversibile",
          "DIALOG": {
            "HEADER": "Sei sicuro di voler eliminare {portalName}?",
            "DESCRIPTION": "Questa è un'azione permanente che non può essere annullata.",
            "CONFIRM_BUTTON_LABEL": "Elimina"
          }
        },
        "EDIT_CONFIGURATION": "Modifica configurazione"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portale creato con successo",
          "ERROR_MESSAGE": "Impossibile creare il portale"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portale aggiornato con successo",
          "ERROR_MESSAGE": "Impossibile aggiornare il portale"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Allegati",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Aggiungi file",
      "DROP_HERE": "Trascina e rilascia i file qui",
      "COPY_LINK": "Copia link",
      "LINK_COPIED": "Link copiato negli appunti",
      "COPY_FAILED": "Impossibile copiare il link",
      "DELETE": "Elimina",
      "CANCEL": "Annulla",
      "QUEUED": "In coda",
      "UPLOADING": "Caricamento",
      "UPLOAD_FAILED": "Impossibile caricare il file",
      "FILE_TOO_LARGE": "Il file supera il limite di dimensione di 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Dizionario di traduzione",
        "DESCRIPTION": "I termini definiti qui vengono aggiunti al prompt di traduzione AI, così da essere sempre tradotti allo stesso modo. Il termine chiave è scritto in {locale}."
      },
      "NEW_TERM": "Nuovo termine",
      "EMPTY_STATE": {
        "TITLE": "Nessun termine nel dizionario",
        "SUBTITLE": "Aggiungi un termine e la sua traduzione per ogni lingua. Quando un articolo viene tradotto, questi termini vengono applicati per mantenere coerente la terminologia del tuo prodotto."
      },
      "LIST": {
        "TERM": "Termine",
        "TRANSLATIONS": "Traduzioni",
        "ACTIONS": "Azioni"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Aggiungi termine",
          "EDIT": "Modifica termine",
          "DESCRIPTION": "Il termine seguente viene applicato durante la traduzione AI degli articoli del tuo centro assistenza.",
          "PORTAL": "Portale",
          "PRIMARY_LANGUAGE": "Lingua principale"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Termine ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Il termine è obbligatorio"
          },
          "DESCRIPTION": {
            "LABEL": "Contesto / note (facoltativo)",
            "PLACEHOLDER": "Quando e come viene utilizzato questo termine, per aiutare il traduttore a disambiguare."
          },
          "TRANSLATIONS": "Traduzioni",
          "TRANSLATION_PLACEHOLDER": "Lascia vuoto per permettere all'AI di tradurre liberamente",
          "AUTO_TRANSLATE": {
            "BUTTON": "Traduci tutto automaticamente",
            "CONFIRM": "Tradurre in {count} lingue con l'AI?",
            "CONFIRM_BUTTON": "Traduci",
            "CANCEL": "Annulla",
            "SUCCESS": "Traduzioni generate — rivedi e salva",
            "ERROR": "Impossibile tradurre automaticamente, riprova"
          }
        },
        "BUTTONS": {
          "CREATE": "Aggiungi termine",
          "EDIT": "Salva",
          "CANCEL": "Annulla"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termine aggiunto con successo",
            "ERROR_MESSAGE": "Impossibile aggiungere il termine, riprova"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termine aggiornato con successo",
            "ERROR_MESSAGE": "Impossibile aggiornare il termine, riprova"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Elimina termine",
          "DESCRIPTION": "Sei sicuro di voler eliminare questo termine? Non verrà più applicato durante la traduzione.",
          "CONFIRM": "Elimina"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termine eliminato con successo",
          "ERROR_MESSAGE": "Impossibile eliminare il termine, riprova"
        }
      }
    }
  }
}
